import { Droplets } from "lucide-react";

const ITEMS = [
  "Higienização profunda",
  "Produtos ecológicos",
  "Atendimento ao domicílio",
  "Secagem rápida",
  "Orçamento gratuito",
  "Lisboa e região",
];

export const Marquee = () => (
  <div className="overflow-hidden py-2" data-testid="marquee-wrapper">
    <div className="relative -mx-3 -rotate-1 overflow-hidden bg-navy py-4" data-testid="marquee">
    <div className="flex w-max animate-marquee items-center gap-8 pr-8">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center gap-8 whitespace-nowrap">
          <span className="font-heading text-sm font-semibold uppercase tracking-[0.18em] text-white/90">
            {item}
          </span>
          <Droplets className="h-4 w-4 shrink-0 text-aqua" aria-hidden="true" />
        </span>
      ))}
    </div>
  </div>
  </div>
);
